import styled from 'styled-components';

export const FilesContainer = styled.div`
  padding: 24px 0;
`;
